module.exports = __webpack_public_path__ + "img/GOLD.05774476.png";